import { Command, CommandRegistry, MenuContribution, MenuModelRegistry } from '@theia/core';
import {
    AbstractViewContribution,
    CommonMenus,
    FrontendApplication,
    FrontendApplicationContribution
} from '@theia/core/lib/browser';
import { injectable } from '@theia/core/shared/inversify';
import { AssetsPanel } from './assets-panel';

const AssetsPanelCommand: Command = { id: 'lvgl-assets:open', label: 'Assets: Open' };

/**
 * Registers AssetsPanel and exposes it via the View menu.
 * Available in both code mode and design mode.
 */
@injectable()
export class AssetsPanelContribution
    extends AbstractViewContribution<AssetsPanel>
    implements FrontendApplicationContribution, MenuContribution
{
    constructor() {
        super({
            widgetId: AssetsPanel.ID,
            widgetName: AssetsPanel.LABEL,
            defaultWidgetOptions: { area: 'left' },
            toggleCommandId: AssetsPanelCommand.id
        });
    }

    async onDidInitializeLayout(_app: FrontendApplication): Promise<void> {
        await this.openView({ activate: false, reveal: false });
    }

    override registerCommands(commands: CommandRegistry): void {
        commands.registerCommand(AssetsPanelCommand, {
            execute: async () => {
                const widget = await this.widgetManager.getOrCreateWidget<AssetsPanel>(AssetsPanel.ID);
                await this.shell.addWidget(widget, { area: 'left' });
                await this.shell.activateWidget(widget.id);
            }
        });
    }

    override registerMenus(menus: MenuModelRegistry): void {
        menus.registerMenuAction(CommonMenus.VIEW_VIEWS, {
            commandId: AssetsPanelCommand.id,
            label: AssetsPanel.LABEL
        });
    }
}
